// components/PitchDeck/03_Solution.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Solution() {
    return (
        <div className="min-h-screen flex items-center bg-white py-20">
            <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    Our Solution
                </h2>
                <p className="text-3xl text-[#4285F4] font-bold mb-8">
                    Arxis Accounting: A Brain for Your Business
                </p>
                <p className="text-2xl text-gray-800 max-w-4xl mx-auto leading-relaxed mb-16">
                    We meet owners where they are — turning simple, everyday processes (sales orders, receipts, payments) into detailed, auditable accounting, tax compliance, and crystal-clear reports — automatically.
                </p>
                <div className="grid md:grid-cols-3 gap-8">
                    <div className="bg-blue-50 p-8 rounded-2xl">
                        <p className="text-2xl font-semibold mb-4">Intelligent Mapping</p>
                        <p className="text-lg">AI converts manual or basic inputs into full transaction trails — no spreadsheets required.</p>
                    </div>
                    <div className="bg-blue-50 p-8 rounded-2xl">
                        <p className="text-2xl font-semibold mb-4">Direct FIRS Integration</p>
                        <p className="text-lg">One-click VAT & withholding submissions — compliant without the headache.</p>
                    </div>
                    <div className="bg-blue-50 p-8 rounded-2xl">
                        <p className="text-2xl font-semibold mb-4">Natural-Language AI</p>
                        <p className="text-lg">Ask questions in plain English — get instant insights like a full-time accountant.</p>
                    </div>
                </div>
                <p className="mt-16 text-3xl font-bold text-gray-900">
                    Non-disruptive onboarding. Immediate value. Total peace of mind.
                </p>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/howitworks">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}